import { render, staticRenderFns } from "./URegister.vue?vue&type=template&id=3d61cfb5&scoped=true&"
import script from "./URegister.vue?vue&type=script&lang=ts&"
export * from "./URegister.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d61cfb5",
  null
  
)

export default component.exports